import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { notify } from './utils/notificationCenter';
import { installConsoleGuard } from './utils/logging';

installConsoleGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Captura global de errores no manejados y promesas rechazadas
window.addEventListener('error', (event) => {
  try {
    notify({
      type: 'error',
      priority: 'high',
      title: 'Error de aplicación',
      message: event?.error?.message || event.message || 'Ocurrió un error inesperado',
      autoClose: true,
      duration: 8,
    });
  } catch {}
});

window.addEventListener('unhandledrejection', (event) => {
  try {
    const reason: any = event.reason || {};
    const message = reason?.response?.data?.message || reason?.message || 'Promesa rechazada sin manejar';
    notify({
      type: 'warning',
      priority: 'high',
      title: 'Error no manejado',
      message,
      autoClose: true,
      duration: 8,
    });
  } catch {}
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
